import { useTheme } from "../../lib/theme";
import { Sun, MoonStars } from "@phosphor-icons/react";

/**
 * Theme switch · botón pill que conmuta Dark ↔ Light.
 * Persiste en localStorage y aplica .light-scope al <html>.
 */
export default function ThemeSwitch({ size = 14 }) {
  const { theme, toggle } = useTheme();
  const isLight = theme === "light";
  return (
    <button
      type="button"
      onClick={toggle}
      className="theme-switch text-xs"
      aria-label={isLight ? "Cambiar a modo oscuro" : "Cambiar a modo claro"}
      title={isLight ? "Modo claro · pulsa para oscuro" : "Modo oscuro · pulsa para claro"}
      data-testid="theme-switch"
    >
      {isLight ? <Sun size={size} weight="fill" className="text-[#FFB703]" />
               : <MoonStars size={size} weight="fill" className="text-[#FFB703]" />}
      <span className="hidden sm:inline tabular-nums">{isLight ? "Claro" : "Oscuro"}</span>
    </button>
  );
}
